import { Component, inject } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../../_shared/services';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';
import { KpiWidgetComponent } from "../../../../../../_shared/components/kpi-widget/kpi-widget.component";
import { AccountFilterRequest } from '../../../../../../_shared/models/account-filter.model';
import { WorkOrderService } from '../../../services/work-order.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-total-work-orders-widget',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './total-work-orders-widget.component.html',
  styleUrl: './total-work-orders-widget.component.scss'
})
export class TotalWorkOrdersWidgetComponent extends BaseWidgetComponent {
  private errorHandlerService: ErrorHandlerService = inject(ErrorHandlerService);
  private workOrderService = inject(WorkOrderService);
  private transloco = inject(TranslocoService);

  public errorMessage: string = '';
  public hasError: boolean = false;
  public totalWorkOrdersPercentageChange: any;
  override title = this.transloco.translate('workOrder.widgets.totalWorkOrders');
  override isLoading: boolean;

  constructor() {
    super(inject(FilterService));
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    return await this.getTotalWorkOrdersKpiStats();
  }

  async getTotalWorkOrdersKpiStats() {
    try {
      this.isLoading = true;
      this.cancelSubject.next();
      const request: AccountFilterRequest = {
        accountIds: this.widgetFilter.accountIds
      };

      const response = await this.workOrderService.getTotalWorkOrdersStatsKpi(request, this.cancelSubject);
      this.value = response.data?.totalValue ?? 0;
      this.totalWorkOrdersPercentageChange = response.data?.percentageChange ?? null;
    } catch (error) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    } finally {
      this.isLoading = false;
    }
  }

  public override formatValue(value: number): string {
    return `${value.toFixed(0)}`;
  }

  openBreakdownModal(): void { }
}